__turbopack_context__.v({
  "searchInput": "searchPart-module-scss-module__pY2IXG__searchInput",
  "searchWrapper": "searchPart-module-scss-module__pY2IXG__searchWrapper",
});
